// extracted by mini-css-extract-plugin
export default {"CRUDTableWrapper":"CRUDTable_styles_CRUDTableWrapper__Y1Pcn"};